import { render } from "./TestimoniosPacientes.vue?vue&type=template&id=47ea062d"
import script from "./TestimoniosPacientes.vue?vue&type=script&lang=js"
export * from "./TestimoniosPacientes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__